(function($) {
    $('#welcomeModal').on('show.bs.modal', function () {
        var $modal = $(this);
        $('input[name="dont_show"]').on('change', function () {
            $('body').removeClass(CONSTANTS.LOADED_CLASS).addClass(CONSTANTS.LOADER_OPAQUE_CLASS);
            $.get('/users/close-welcome-message', function (data) {
                if (data.success) {
                    $modal.modal('hide');
                }
                $('body').removeClass(CONSTANTS.LOADER_OPAQUE_CLASS).addClass(CONSTANTS.LOADED_CLASS);
            });
        });
    });

    if (CONSTANTS.SHOW_WELCOME_MESSAGE) {
        $('#welcomeModal').modal('show');
    }
}(jQuery));